import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import Routing from "../../../../Routing.ts";

export default function MitHiperArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Når du bliver kunde hos Hiper, får du adgang til Mit Hiper &ndash; din personlige selvbetjening.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Sådan logger du ind</h2>
                        <ol className="list list--number">
                            <li><p>Tryk på <Link to={Routing.Selfcare.Index}>Mit&nbsp;Hiper</Link> oppe i højre hjørne her på siden.</p></li>
                            <li>
                                <p>
                                    Brug din e-mail og kode for at logge ind.<br/>
                                    Sæt et flueben i <strong>Husk mig</strong> for at logge ind automatisk næste gang.
                                </p>
                                <p>
                                    <strong>Har du ikke oprettet en bruger endnu?</strong>
                                    <br/>
                                    Tryk <Link to={Routing.Selfcare.LoginCreate}>her</Link> og indtast din mailadresse.
                                    Så får du en mail, hvor du kan oprette en bruger.
                                </p>
                            </li>
                        </ol>
                    </div>
                    <img
                        className="paragraph-image br1 box-shadow"
                        src={imageMap.help.subscription.selfcare_login}
                        alt="Grafik som viser log ind siden til Mit Hiper."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Få overblik over dit abonnement</h2>
                        <p>
                            Under <Link to={Routing.Selfcare.Account}>Profil</Link> kan du bl.a. finde følgende oplysninger om dit abonnement:
                        </p>
                        <ul className="list list--bullet">
                            <li><p>Se dit produkt og din pris.</p></li>
                            <li><p>Se dit udstyr og dets specifikationer.</p></li>
                            <li><p>Se alle oplysningerne registreret på dit abonnement.</p></li>
                            <li><p>Skift dit telefonnummer og e-mail.</p></li>
                            <li><p>Se din nuværende hastighed.</p></li>
                        </ul>
                    </div>
                    <img
                        className="paragraph-image box-shadow"
                        src={imageMap.help.subscription.selfcare_profile}
                        alt="Grafik af oversigten over dine oplysninger."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Skift betalingskort</h2>
                        <p>
                            Vi har sørget for, at det er både nemt og trygt for dig som kunde at opdatere og skifte dit betalingskort.
                            Du kan både ændre dit betalingskort på <Link to={Routing.Selfcare.Index}>forsiden af Mit Hiper</Link> og under <Link to={Routing.Selfcare.Card}>Betaling</Link>.
                        </p>
                    </div>
                    <img
                        className="paragraph-image br1 box-shadow"
                        src={imageMap.help.subscription.selfcare_card}
                        alt="Grafik af betalingskortoversigten."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hold styr på dine regninger</h2>
                        <p>
                            Under <Link to={Routing.Selfcare.Bills}>Regninger</Link> kan du nemt få overblik over dine regninger og eventuelle tilgodehavender. Du kan downloade alle dine regninger og samtidig se, hvornår din næste regning skal betales.
                        </p>
                        <ul className="list list--bullet">
                            <li><p>Se alle dine regninger.</p></li>
                            <li><p>Se dit tilgodehavende.</p></li>
                            <li><p>Hvornår trækker vi næste regning.</p></li>
                        </ul>
                    </div>
                    <img
                        className="paragraph-image box-shadow"
                        src={imageMap.help.subscription.selfcare_invoices}
                        alt="Grafik af regningsoversigten."
                    />
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "betalingsmuligheder",
                        "name": "Betalingsmuligheder"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "forstaa-din-regning",
                        "name": "Forstå din regning"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "gravning",
                        "name": "Gode råd inden du graver"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    }
                ]}
            />
        </>
    )
}
